import { Action, createReducer, on } from '@ngrx/store';

import { DataSetupActions } from './data-setup.actions';
import { DataSetupModel } from '@core/data-access';

export const DATA_SETUP_FEATURE_KEY = 'dataSetup';

export interface DataSetupState {
  dataSetup?: DataSetupModel | null;
  loaded: boolean; // has the DataSetup list been loaded
  error?: string | null; // last known error (if any)
}

export interface DataSetupPartialState {
  readonly [DATA_SETUP_FEATURE_KEY]: DataSetupState;
}

export const initialDataSetupState: DataSetupState = {
  // set initial required properties
  loaded: false,
};

const reducer = createReducer(
  initialDataSetupState,
  on(DataSetupActions.init, state => ({ ...state, loaded: false, error: null })),
  on(DataSetupActions.loadSuccess, (state, { dataSetup }) => ({ ...state, dataSetup, loaded: true })),
  on(DataSetupActions.loadFailure, (state, { error }) => ({ ...state, error })),
);

export function dataSetupReducer(state: DataSetupState | undefined, action: Action) {
  return reducer(state, action);
}
